import { ipsos, supuesto } from ".";

// Lámina 96 (móvil, base 400) y lámina 98 (hogar, TV pagada base 206).
const P_OPERADOR = "¿Cuál es su operador de telefonía móvil?";
const P_PLAN = "¿Su plan es prepago o postpago?";
const P_CORPORATIVO = "¿Tiene teléfono corporativo (de la empresa)?";
const P_CAMBIARIA = "¿Cambiaría de operador por una oferta tentadora?";
const P_INTERNET_FIJO = "¿Tiene internet fijo en su casa?";
const P_TV_PAGADA = "¿Tiene TV pagada o TV cable?";
const P_OPERADOR_TV = "¿Cuál es su operador de TV pagada?";

export const IPSOS_MOVIL = {
  // share = Ipsos (lámina 96); precioMes = supuesto comercial (CLP)
  operadores: {
    ENTEL: {
      share: ipsos(0.53, { lamina: 96, pregunta: P_OPERADOR, base: 400 }),
      precioMes: supuesto(20000, { nota: "precio mensual del plan" }),
    },
    WOM: {
      share: ipsos(0.334, { lamina: 96, pregunta: P_OPERADOR, base: 400 }),
      precioMes: supuesto(18000, { nota: "precio mensual del plan" }),
    },
    CLARO: {
      share: ipsos(0.11, { lamina: 96, pregunta: P_OPERADOR, base: 400 }),
      precioMes: supuesto(15000, { nota: "precio mensual del plan" }),
    },
    VTR: {
      share: ipsos(0.026, { lamina: 96, pregunta: P_OPERADOR, base: 400 }),
      precioMes: supuesto(17000, { nota: "precio mensual del plan" }),
    },
  },

  // No se usa programáticamente hoy (el badge "100%" está hardcodeado en el JSX)
  tipoPlan: {
    postpago: ipsos(1, { lamina: 96, pregunta: P_PLAN, base: 400 }),
    prepago: ipsos(0, { lamina: 96, pregunta: P_PLAN, base: 400 }),
  },

  telefonoCorporativo: ipsos(0.362, { lamina: 96, pregunta: P_CORPORATIVO, base: 400 }),
  cambiariaPlan: ipsos(0.299, { lamina: 96, pregunta: P_CAMBIARIA, base: 400 }),
  // No se usa programáticamente hoy
  noCambiaria: ipsos(0.701, { lamina: 96, pregunta: P_CAMBIARIA, base: 400 }),
};

export const IPSOS_HOGAR = {
  tieneInternetFijo: ipsos(0.902, { lamina: 98, pregunta: P_INTERNET_FIJO, base: 400 }),
  tieneTvPagada: ipsos(0.514, { lamina: 98, pregunta: P_TV_PAGADA, base: 400 }),

  // Operadores de TV pagada (lámina 98, base 206) — no son proveedores de internet
  proveedores: {
    Movistar: ipsos(0.354, { lamina: 98, pregunta: P_OPERADOR_TV, base: 206 }),
    VTR: ipsos(0.316, { lamina: 98, pregunta: P_OPERADOR_TV, base: 206 }),
    Entel: ipsos(0.15, { lamina: 98, pregunta: P_OPERADOR_TV, base: 206 }),
    Mundo: ipsos(0.104, { lamina: 98, pregunta: P_OPERADOR_TV, base: 206 }),
    Claro: ipsos(0.057, { lamina: 98, pregunta: P_OPERADOR_TV, base: 206 }),
    GTD: ipsos(0.019, { lamina: 98, pregunta: P_OPERADOR_TV, base: 206 }),
  },

  precioMensualPromedio: supuesto(18000, { nota: "precio mensual promedio por hogar (CLP)" }),
};

export const ESCENARIOS_CAPTACION_TELCOS = [
  supuesto(5, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
  supuesto(15, { nota: "escenario de captación de mercado" }),
  supuesto(20, { nota: "escenario de captación de mercado" }),
];

// No se muestra en la UI hoy — referencia interna del simulador de churn
export const COSTO_ADQUISICION_REF = supuesto(18000000, { nota: "costo de adquisición de referencia (pauta 3 meses)" });
